import { render, staticRenderFns } from "./Webworthy.vue?vue&type=template&id=c20b37b4&scoped=true&"
import script from "./Webworthy.vue?vue&type=script&lang=js&"
export * from "./Webworthy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20b37b4",
  null
  
)

export default component.exports